<template>
  <div class="ui middle aligned center aligned grid">
    <div class="column">
      <div class="ui success message" v-if="showSuccessMessage">
        {{ $t('pages.forgot.form.success') }}
      </div>
      <div class="ui blue header centered">
        <div class="content">
          {{ $t('pages.forgot.header') }}
        </div>
      </div>
      <form class="ui large form" @submit.prevent="sendForm">
        <div class="ui stacked segment">
          <div class="field" :class="{ 'error' : errors.has('email') }">
            <div class="ui input">
              <input type="email" v-model="email" :data-vv-as="$t('pages.forgot.form.email')" name="email"
                     :placeholder="$t('pages.forgot.form.email')" v-validate="'required|email'">
            </div>
            <span style="color:red;" v-if="errors.has('email')">{{ errors.first('email') }}</span>
          </div>
          <button type="submit" class="ui large fluid blue button" :disabled="errors.any()">
            {{ $t('pages.forgot.form.button') }}
          </button>
        </div>
      </form>
      <div class="ui message centered">
        {{ $t('pages.forgot.goback') }}
        <router-link :to="{name: 'login'}">{{ $t('pages.forgot.loginlink') }}</router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ForgotPassword',

  layout: 'default',

  data() {
    return {
      email: '',
      showSuccessMessage: false
    }
  },

  methods: {
    sendForm() {
      this.$validator.validateAll()
        .then(result => {
          if (result) {
            // send post request
            this.axios.post('/reset-password', {
              email: this.email
            })
              .then(({data}) => {
                if (data.success) {
                  this.showSuccessMessage = true
                } else {
                  this.errors.add({field: 'email', msg: data.msg})
                }
              }).catch()
          }
        }).catch()
    }
  }
}
</script>

<style lang="scss" scoped>
.ui.middle.aligned.center.aligned.grid {
  height: 100vh;
  width: 100%;
  justify-content: center;
}

.ui.middle.aligned.center.aligned.grid > .column {
  width: 450px;

  @media screen and (max-width: 768px) {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/auth/ForgotPassword.vue